export default function Accesses(userInfo, workItem) {
  var userId = userInfo.Id;
  var status = workItem.Status;
  var roles = getRolesToThisWorkitem();
  var AccessesObject = {
    HasAccess: false,
    CanShareWithCoAuthors: false,
    CanViewRevision: false,
    CanViewCoAuthors: false,
    CanSetReadyForReview: false,
    CanViewReviewStatus: false,
    CanSetReadyForPublish: false,
    CanViewPublishStatus: false,
    CanApproveReviews: false,
    CanAddNotes: false,
    CanAddLinks: false,
    CanPublish: false,
    //Default to False. Will change in LawPage.js if there is any html changes in summary change. If true, Endringer tab will be activated
    HasLawChanges: false,
    roles: roles,
  };

  HasAccess();
  CanShareWithCoAuthors();
  CanViewRevision();
  CanViewCoAuthors();
  CanSetReadyForReview();
  CanViewReviewStatus();
  CanSetReadyForPublish();
  CanViewPublishStatus();
  CanApproveReviews();
  CanAddNotes();
  CanAddLinks();
  CanPublish();

  function getRolesToThisWorkitem() {
    let roles = {
      DevOps: false,
      KarnovContentEditor: false,
      KarnovEditor: false,
      KarnovEmployee: false,
      Reviewer: false,
      CoAuthor: false,
      Author: false,
      KarnovReviewer: false,
      // sub roles
      ContentReviewer: false,
      ProofReader: false,
      EUReviewer: false,
    };

    if (userId != null) {
      if (userId == workItem.AuthorId) {
        roles.Author = true;
      }
      if (
        (workItem.CoAuthorIds != null && workItem.CoAuthorIds.includes(userId)) ||
        (workItem.SharedWith != null && workItem.SharedWith.includes(userId))
      ) {
        roles.CoAuthor = true;
      }

      if (checkMatch(workItem.KarnovReviewer, userId)) {
        roles.KarnovReviewer = true;
      }

      if (checkMatch(workItem.ContentReviewer, userId)) {
        roles.Reviewer = true;
        roles.ContentReviewer = true;
      }
      if (checkMatch(workItem.ProofReader, userId)) {
        roles.Reviewer = true;
        roles.ProofReader = true;
      }
      if (
        workItem.IsEUReviewable != null &&
        workItem.IsEUReviewable != false &&
        checkMatch(workItem.EUReviewer, userId)
      ) {
        roles.Reviewer = true;
        roles.EUReviewer = true;
      }

      if (workItem.KarnovEditorId == userId) {
        roles.KarnovEditor = true;
      }
      if (userInfo.IsKarnovContentEditor) {
        roles.KarnovContentEditor = true;
      }
      if (userInfo.IsKarnovDevOps) {
        roles.DevOps = true;
      }
      if (userInfo.IsKarnovEmployee) {
        roles.KarnovEmployee = true;
      }
    }
    return roles;
  }

  function checkMatch(reviewer, userId) {
    if (reviewer == null) return false;
    return reviewer.Id == userId;
  }

  function HasAccess() {
    if (
      roles.DevOps == true ||
      (roles.Author == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovContentEditor == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovEditor == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovEmployee == true &&
        (status == "ReadyForPublish" || status == "Published" || status == "Delivered")) ||
      (roles.Reviewer == true && status == "ReadyForReview") ||
      (roles.CoAuthor == true && (status == "Init" || status == "ReadyForReview"))
    ) {
      AccessesObject.HasAccess = true;
    }
    // UserRoleUtil.DevOps => true,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEmployee => workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.Reviewer => workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.CoAuthor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
  }

  function CanShareWithCoAuthors() {
    if (
      (roles.DevOps == true && (status == "Init" || status == "ReadyForReview")) ||
      (roles.Author == true && (status == "Init" || status == "ReadyForReview")) ||
      (roles.KarnovContentEditor == true && (status == "Init" || status == "ReadyForReview"))
    ) {
      AccessesObject.CanShareWithCoAuthors = true;
    }

    // UserRoleUtil.DevOps => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview,
  }

  function CanViewRevision() {
    if (
      (workItem.IsRevision == true || workItem.IsAuthorValidated == true) &&
      (roles.DevOps == true || roles.KarnovReviewer == true)
    ) {
      AccessesObject.CanViewRevision = true;
    }
  }

  function CanViewCoAuthors() {
    if (
      roles.DevOps == true ||
      (roles.Author == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovContentEditor == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovEditor == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovEmployee == true &&
        (status == "ReadyForPublish" || status == "Published" || status == "Delivered")) ||
      (roles.CoAuthor == true && (status == "Init" || status == "ReadyForReview"))
    ) {
      AccessesObject.CanViewCoAuthors = true;
    }

    // UserRoleUtil.DevOps => true,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEmployee => workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.CoAuthor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview,
  }

  function CanSetReadyForReview() {
    if (
      status == "Init" &&
      (roles.DevOps == true || roles.Author == true || roles.KarnovContentEditor == true)
    ) {
      AccessesObject.CanSetReadyForReview = true;
    }

    // UserRoleUtil.DevOps => workItemStatus == WorkItemStatusUtil.Init,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.Init,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.Init,
  }

  function CanViewReviewStatus() {
    if (
      (roles.DevOps == true && status != "Init") ||
      (roles.Author == true &&
        (status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.CoAuthor == true && status == "ReadyForReview") ||
      (roles.Reviewer == true && status == "ReadyForReview") ||
      (roles.KarnovContentEditor == true &&
        (status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered")) ||
      (roles.KarnovEditor == true &&
        (status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered"))
    ) {
      AccessesObject.CanViewReviewStatus = true;
    }
    // UserRoleUtil.DevOps => workItemStatus != WorkItemStatusUtil.Init,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.CoAuthor => workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.Reviewer => workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEditor => workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
  }

  function CanSetReadyForPublish() {
    if (
      status == "ReadyForReview" &&
      (roles.DevOps == true || roles.Author == true || roles.KarnovContentEditor == true)
    ) {
      AccessesObject.CanSetReadyForPublish = true;
    }

    // UserRoleUtil.DevOps => workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.ReadyForReview,
  }

  function CanViewPublishStatus() {
    if (
      (roles.DevOps == true && status != "Init") ||
      ((roles.Author == true || roles.KarnovEmployee == true) &&
        (status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "Published" ||
          status == "Delivered"))
    ) {
      AccessesObject.CanViewPublishStatus = true;
    }
    // UserRoleUtil.DevOps => workItemStatus != WorkItemStatusUtil.Init && workItemStatus != WorkItemStatusUtil.ReadyForReview,
    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
    // UserRoleUtil.KarnovEmployee => workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Published || workItemStatus == WorkItemStatusUtil.Delivered,
  }

  function CanApproveReviews() {
    if (status == "ReadyForReview" && (roles.DevOps == true || roles.KarnovContentEditor == true)) {
      AccessesObject.CanApproveReviews = true;
    }
  }

  function CanAddNotes() {
    if (
      (roles.DevOps == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "DevOps" ||
          status == "Deleted")) ||
      (roles.Author == true &&
        (status == "Init" || status == "ReadyForReview" || status == "DevOps")) ||
      (roles.KarnovContentEditor == true &&
        (status == "Init" ||
          status == "ReadyForReview" ||
          status == "ReadyForPublish" ||
          status == "DevOps"))
    ) {
      AccessesObject.CanAddNotes = true;
    }
    // UserRoleUtil.DevOps => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish || workItemStatus == WorkItemStatusUtil.Deleted,

    // UserRoleUtil.Author => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.DevOps,

    // UserRoleUtil.KarnovContentEditor => workItemStatus == WorkItemStatusUtil.Init || workItemStatus == WorkItemStatusUtil.ReadyForReview || workItemStatus == WorkItemStatusUtil.ReadyForPublish|| workItemStatus == WorkItemStatusUtil.DevOps,
  }

  function CanAddLinks() {
    if (hasLinkingFeatureRole() && hasLinkingFeatureStatus()) {
      AccessesObject.CanAddLinks = true;
    }

    // Temporarily restricted to internal Karnov roles plus ProofReader.
  }

  function hasLinkingFeatureRole() {
    return (
      roles.DevOps == true ||
      roles.KarnovContentEditor == true ||
      roles.KarnovEditor == true ||
      roles.KarnovEmployee == true ||
      roles.ProofReader == true
    );
  }

  function hasLinkingFeatureStatus() {
    return status == "Init" || status == "ReadyForReview" || status == "ReadyForPublish";
  }

  function CanPublish() {
    if (status == "ReadyForPublish" && (roles.DevOps == true || roles.KarnovEmployee == true)) {
      AccessesObject.CanPublish = true;
    }
    // UserRoleUtil.DevOps => workItemStatus == WorkItemStatusUtil.ReadyForPublish,
    // UserRoleUtil.KarnovEmployee => workItemStatus == WorkItemStatusUtil.ReadyForPublish,
  }

  return AccessesObject;
}
